import { shuffle } from "./pureFunctions";

/* Tip: Collapse line 7! */

// 100 most common english words according to
// https://www.espressoenglish.net/the-100-most-common-words-in-english
const words = [
  "the",
  "at",
  "there",
  "some",
  "my",
  "of",
  "be",
  "use",
  "her",
  "than",
  "and",
  "this",
  "an",
  "would",
  "first",
  "a",
  "have",
  "each",
  "make",
  "water",
  "to",
  "from",
  "which",
  "like",
  "been",
  "in",
  "or",
  "she",
  "him",
  "call",
  "is",
  "one",
  "do",
  "into",
  "who",
  "you",
  "had",
  "how",
  "time",
  "oil",
  "that",
  "by",
  "their",
  "has",
  "its",
  "it",
  "word",
  "if",
  "look",
  "now",
  "he",
  "but",
  "will",
  "two",
  "find",
  "was",
  "not",
  "up",
  "more",
  "long",
  "for",
  "what",
  "other",
  "write",
  "down",
  "on",
  "all",
  "about",
  "go",
  "day",
  "are",
  "were",
  "out",
  "see",
  "did",
  "as",
  "we",
  "many",
  "number",
  "get",
  "with",
  "when",
  "then",
  "no",
  "come",
  "his",
  "your",
  "them",
  "way",
  "made",
  "they",
  "can",
  "these",
  "could",
  "may",
  "I",
  "said",
  "so",
  "people",
  "part",
];

const expand = (str, includeUppercase, n) => {
  const lowers = (str + " ").repeat(n);
  const upper = str.charAt(0).toUpperCase() + str.slice(1);
  const result = includeUppercase ? lowers + (upper + " ").repeat(n) : lowers;
  return result;
};

const assemble = (includeUppercase = false, n = 8) =>
  shuffle(words)
    .map((word) => expand(word, includeUppercase, n))
    .join("");

export default assemble;
